import { useRoleLabels } from '@app/utils/hooks/translations/useRoleLabel';
import { isEmpty } from '@app/utils/isEmpty';
import { abbreviateFirstName } from '@app/utils/string';
import { User as UserType } from '@typings';
import { useTranslation } from 'react-i18next';

import { Avatar } from './Avatar';

interface Props {
  user: UserType;
  companyName: string;
}

export const User = ({ user, companyName }: Props) => {
  const { t } = useTranslation(['common']);
  const roleLabels = useRoleLabels();
  const avatarTitle = !isEmpty(user.name) ? user.name : user.email;
  const username = abbreviateFirstName(user.name);

  return (
    <div className="flex items-center gap-2">
      <Avatar title={avatarTitle} />
      <div className="hidden flex-col text-left sm:flex">
        <p data-sentry-mask className="max-w-36 truncate body-2">
          {username}
        </p>
        <p className="text-neutral-60 body-5">
          {user.isAdmin ? t('common:role.admin') : t('common:role_at_company', { company: companyName, role: roleLabels[user.access] })}
        </p>
      </div>
    </div>
  );
};
